<chapter-step
  [title]="'Which method of time tracking works best for your team?' | translate"
  [nextButtonLoading]="nextButtonLoading"
  [nextButtonDisabled]="timeTrackingMethod.value === null"
  (next)="onNext()"
>
  <sb-radio-group [formControl]="timeTrackingMethod" class="flex flex-col gap-2">
    @for (option of timeTrackingMethods; track option.value) {
      <sb-radio
        class="p-1"
        [name]="'time-tracking-method'"
        [value]="option.value"
        [label]="option.label"
        [description]="option.description"
      />
    }
  </sb-radio-group>
</chapter-step>
